import React, { useEffect, useState } from "react";
import { useLocation, Route, Routes } from "react-router-dom";
import Cookies from 'universal-cookie';
import routes from "../core/routes/routes";
import Sidebar from "./sidebar/Sidebar";
import { AuthenticationService } from "../core/services/authentication.service";
import { Helper, HelperConfig, HelperRedirect, HelperWebView } from "../core/services/helper/helper.service";
import AndroidBack from "../core/services/androidBack.service";
import ModalCookieBanner from "../components/Modals/ModalCookieBanner";
import Analytics from "../components/analytics/analytics";
import Emitter from "../core/services/emitter";
import ModalIAgree from "../components/Modals/ModalIAgree";

declare global {
  interface Window {
    AndroidBack: any;
  }
}

const App = () => {
  const [clusterCalled, setClusterCalled] = useState(process.env.NODE_ENV === 'development');
  const isEmbedded = Helper.isEmbedded();
  const cookies = new Cookies();
  const [analyticCookies, setAnalyticCookies] = useState(cookies.get('acceptedAnalyticsCookies'));
  const analytics = new Analytics();
  const [modalIAgreeIsOpen, setModalIAgreeIsOpen] = useState<boolean>(false);
  const location = useLocation();

  useEffect(() => {

    if (!HelperWebView.isAndroidWebview() && !HelperWebView.isIOSWebview()) {
      // Load the Google Identity Services script for Google Sign-In in browsers
      const script = document.createElement('script');
      script.src = "https://accounts.google.com/gsi/client";
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);
    }

    checkForRedirect();

    if (process.env.NODE_ENV !== 'development') {
      fetchCluster();
    }
    if (HelperWebView.isAndroidWebview()) {
      window.AndroidBack = AndroidBack.handleAndroidBack;
    }

    if (analyticCookies) {
      setTimeout(() => {
        analytics.init();
      }, 2000);
    }
    // Check if the user is already logged in and redirect to the client
    const currentPath = location.pathname;
    if (['/', '/login', '/registo'].includes(currentPath) && !window.location.hostname.includes("localhost")) {
      (async () => {
        for (let i = 0; i < 1; i++) {
          const sessionToken = cookies.get('sessionToken');
          if (sessionToken) {
            const result = await AuthenticationService.userLoggedIn(sessionToken);
            if (result?.redirect_type === "401" || result?.redirect_type === "Error") {
              Helper.removeCookie('sessionToken');
              continue;
            }
            if (result?.redirect_type === "VERTICAL") {
              break;
            }
            if (result?.redirect_type === "COMPANIES") {
              let latestCompany = cookies.get('kssreturncompany');
              if (latestCompany) {
                if (HelperConfig.isQAenvironment() && latestCompany.includes('.qa')){
                  HelperRedirect.goToAppClient(latestCompany);
                  break;
                }
                if (!HelperConfig.isQAenvironment() && !latestCompany.includes('.qa')){
                  HelperRedirect.goToAppClient(latestCompany);
                  break;
                }            
              }
              HelperRedirect.goToAppClient(result?.domain + (HelperConfig.isQAenvironment() ? '.qa' : ''));
              break;
            }
          } else {
            break;
          }
        }
      })();
    }
    
    Emitter.on('OPEN_IAGREE_TEXT', openiAgreeModal);
    const searchParams = new URLSearchParams(location.search);
    if (searchParams.has('privacy')) {
      setTimeout(() => {
        Emitter.emit("OPEN_IAGREE_TEXT", null);
      }, 500);
    }

    return () => {
      Emitter.off('OPEN_IAGREE_TEXT', openiAgreeModal);
      // Set window.AndroidBack to null when the component unmounts
      window.AndroidBack = null;
      analytics.unmount(); // Unmount UXCam
    };
  // eslint-disable-next-line 
  }, []);

  useEffect(() => {
    if (analyticCookies) {
      setTimeout(() => {
        analytics.init();
      }, 2000);
    } 
  // eslint-disable-next-line 
  }, [analyticCookies]);

  const openiAgreeModal = () => {
    setModalIAgreeIsOpen(true);
  }
  const closeIAgreeModal = () => {
    setModalIAgreeIsOpen(false);
  };

  const renderModalIAgree = (handler: any) => {
    return (
      <ModalIAgree
        modalIsOpen={modalIAgreeIsOpen}
        onClose={() => closeIAgreeModal()}
        onConfirm={() => closeIAgreeModal()}
      />
    );
  };

  const updateAnalyticCookies = (accepted: boolean): void => {
    setAnalyticCookies(accepted);
  };

  const checkForRedirect = () => {
    // Check for the 'ref' parameter and redirect if it exists
    const urlParams = new URLSearchParams(window.location.search);
    const ref = urlParams.get('ref');
    if (ref) {
      const decodedRef = decodeURIComponent(ref);
      window.location.href = decodedRef;
      // Remove the 'ref' parameter from the URL
      urlParams.delete('ref');
      const newUrl = `${window.location.pathname}?${urlParams.toString()}`;
      window.history.replaceState({}, document.title, newUrl);
    }
  }
  const fetchCluster = () => {
    try {
      AuthenticationService.fetchCluster();
      setTimeout(() => {
        setClusterCalled(true);
      }, 100);
    } catch (error) {
      setClusterCalled(false);
    } 
  }

  if (clusterCalled) {
    return (
      <React.Fragment>
        <div className="app">
          {!isEmbedded && <Sidebar />}
          <div className="main-content">
            <Routes>
              {routes.map((route) => (
                <Route key={route.path} path={route.path} element={route.element} />
              ))}
            </Routes>
          </div>
          <ModalCookieBanner updateAnalyticCookies={updateAnalyticCookies}/>
          {renderModalIAgree(null)}
        </div>
      </React.Fragment>
    );
  } else {
    return (
      <React.Fragment>
        <p> App Keymaster Cliente a ser carregada... </p>
      </React.Fragment>
    );
  }
};
export default App;